@let list = valueAsStringSg();

@if (list.length) {
  <div class="atn-list-value__container">
    @for (element of list; track $index) {
      <atn-ds-tag [text]="element" />
    }
  </div>
} @else {
  <p class="atn-list-value__empty-label">None</p>
}
